import { Attributes, ModelBase, NeoModel, Validation } from "@singularsystems/neo-core";

@NeoModel
export default class FileTypeConfigurationLookup extends ModelBase {

    public staticFileSpecId: number = 0;

    @Attributes.Date()
    public activeStartDate: Date | null = null;

    @Attributes.Date()
    public activeEndDate: Date | null = null;

    public rawDataTableName: string = "";

    public rawGenericTableName: string = "";

    public errorHoldingTableName: string = "";

    public columnCount: number = 0;

    public hasCheckConstraintInd: boolean = false;

    public startColumnHeaderRead: number = 0;

    public containHeaderInd: boolean = false;

    public isSingleFileInd: boolean = false;

    public isIgnoredInd: boolean = false;

    public fileSpecPropertiesConcatenated: string = "";

    public addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        rules.failWhen(c => c.columnCount <= 0, "Column count must be above zero.");
    }
}